import { Coord } from "../types/Interface"

export default function isPortail(dim:{ WIDTH:number, HEIGHT:number}, CENTER_OF_CIRCLE:Coord):Coord {
  if (dim.WIDTH > dim.HEIGHT) {
    return CENTER_OF_CIRCLE
  }
  return {
    x: dim.WIDTH / 2,
    y: dim.HEIGHT / 2
  }
}